<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li><a href="/#/pit" v-on:click="sendMsg">井下振动监测</a></li>
            <li class="active">矿井安全类</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">矿井安全类</h1>
            <hr>
            <p class="titleP">矿井安全的重要性</p>
            <p>随着社会经济与科学技术的发展,尤其是综合机械化设备的应用,极大地促进了矿井开采技术的进步。但矿井开采机械化的主要缺点在于应变能力太差，不能随着地质情况的变化而做出及时地调整。井下遇到地质异常体较多的是较小地质异常体，可通过振动监测的手段定位异常体的大概位置，提高矿井的安全性。</p>
            <p class="titleP">矿井安全检测的步骤</p>
            <p>运用振动传感器来矿井物探，寻找矿井震源。首先在矿井下布下众多传感器，然后接上数据采集仪，最后通过数据分析，看各个点振动信号的传递时间来寻找井下震源。</p>
            <p class="titleP">矿井安全检测的设备</p>
            <p>传感器：BY-S150M。该传感器为速度型传感器，通频带为4.5Hz—125Hz，带自校准功能，灵敏度为22V/（m/s），防护等级为IP68。
              数据采集仪选择：D3000型数据采集仪。D3000型数据采集仪更适合监测项目。
            </p>
            <p class="titleP">矿井安全检测的流程图</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/pit/mine/f1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p class="titleP">矿井安全检测的案例</p>
            <p>某物探公司使用BY-S150M传感器测试井下矿震，通过识别振动信号的传递时间来寻找震源。 </p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/pit/mine/c1.jpg" alt="" style="width:100%;height:auto;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/pit/mine.vue